var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EChart',{attrs:{"width":_vm.chart.width,"height":_vm.chart.height,"option":_vm.chart.option,"group":_vm.group,"no-resize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }